import { NotificationSeverity } from "./models";
import { makeAutoObservable } from "mobx";
export class NotificationStoreImpl {
    constructor(rootStore) {
        this.notifications = [];
        this.rootStore = rootStore;
        makeAutoObservable(this);
    }
    enqueueSnackbar(message, severity) {
        this.notifications.push({
            key: new Date().getTime() + Math.random(),
            message: message,
            variant: severity ? severity : NotificationSeverity.ERROR,
        });
    }
    removeSnackbar(key) {
        this.notifications = this.notifications.filter((notification) => {
            return notification.key !== key;
        });
    }
    handleError(error) {
        let message = "";
        if (error.response && error.response.body) {
            message = ": " + error.response.body["detail"];
        }
        console.log(error.message + message);
        this.enqueueSnackbar(error.message + message);
    }
}
